import React from 'react'
import { getImageUrl } from '../../../../../util'
import { LEGEND_COLOR_MAP_V2 } from '../../../../../constants'
import { MuiImage } from '../../../../../components'
import {
  GraphContentLevel2,
  GraphRow,
  SliderWrap,
  GraphRowDetails,
} from './style'
import LhsHeading from '../LhsHeading/LhsHeading'

const BrandImageryRowL2 = ({ row, onChange, canMove = false, parentHeading }) => {
  const imageryChangeHandler = (value, imagery) => {
    if (!canMove) return
    const newData = row?.data?.map((item) => {
      if (item.logoName === imagery.logoName) {
        return {
          ...item,
          scale: value,
        }
      }
      return item
    })
    onChange({
      ...row,
      data: newData,
    })
  }

  return (
    <GraphContentLevel2 className='brandImageryRowAppendices'>
      <LhsHeading row={{ ...row, parentHeading: parentHeading }} level={2} />

      <GraphRow className='list'>
        {row?.data?.map((rowItem, index) => {
          const percent = ((rowItem.scale + 3) / 6) * 100

          let bgColor = LEGEND_COLOR_MAP_V2.Negative
          if (percent > 33 && percent < 66) {
            bgColor = LEGEND_COLOR_MAP_V2.Mixed
          }
          if (percent >= 66) {
            bgColor = LEGEND_COLOR_MAP_V2.Positive
          }

          let sliderWrapStyle = {}
          if (percent > 50) {
            const img = new Image()
            img.src = getImageUrl('logos', rowItem?.logoImg, 'png')
            const maxHeight = 15
            const aspectRatio = img.width / img.height
            const adjustedWidth = maxHeight * aspectRatio
            sliderWrapStyle = { marginLeft: `-${adjustedWidth + 17}px` }
          }

          return (
            <SliderWrap
              key={index}
              percent={percent}
              color={bgColor}
              disabled={!canMove}
              logoname={rowItem.logoName}
              scalevalue={rowItem.scale}
              logo={getImageUrl('logos', rowItem?.logoImg, 'png')}
            >
              {canMove ? (
                <input
                  disabled={!canMove}
                  onChange={(e) => imageryChangeHandler(e.target.value, rowItem)}
                  step={0.01}
                  type='range'
                  value={rowItem.scale}
                  min={-3}
                  max={3}
                  className='slider'
                />
              ) : (
                <>
                  <span className='sliderValue' data-percent={percent}></span>
                  <MuiImage
                    src={getImageUrl('logos', rowItem?.logoImg, 'png')}
                    style={{ marginLeft: sliderWrapStyle.marginLeft || 0 }}
                  />
                </>
              )}
            </SliderWrap>
          )
        })}
      </GraphRow>
      <GraphRowDetails className='graphRowDetails'></GraphRowDetails>
    </GraphContentLevel2>
  )
}

export default BrandImageryRowL2
